// extracted by mini-css-extract-plugin
export default {"amp_loader":"loader_amp_loader__MJvEz","amp_loader_image":"loader_amp_loader_image__BgDVw"};